import { Transaction } from '../../payment/models/transaction';
export interface IUser {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;
    UserName: string;
    Password: string;
    Roles: string[];
    CustomerId: number;
   DistrictId: number;
}

export class User {
    public Id: number;
    public Email: string;
    public FirstName: string;
    public LastName: string;
    public UserName: string;
    public Password: string;
    public Roles: string[];
    public CustomerId: number;
    public DistrictId: number;
    public Redirected: string;
    public RedemptionCode: string;
    public Transaction: Transaction;
    public AgreeTos: boolean;

    //constructor();
    //constructor(obj: IUser);
    constructor(obj?: any) {
        this.Id = obj && obj.Id || '';
        this.Email = obj && obj.Email || '';
        this.FirstName = obj && obj.FirstName || '';
        this.LastName = obj && obj.LastName || '';
        this.UserName = obj && obj.UserName || '';
        this.Password = obj && obj.Password || '';
        this.Roles = obj && obj.Roles && <Array<string>>(obj.Roles) || null;
        this.CustomerId = obj && obj.CustomerId || 0;
        this.DistrictId = obj && obj.CustomerId || 0;
        this.Redirected = obj && obj.Redirected || '';
        this.RedemptionCode = obj && obj.Code || '';
        this.Transaction = obj && obj.Transaction || '';
        this.AgreeTos = obj && obj.AgreeTos || null;
    }
}
